import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import EntryPoint from "../../pages/Leads/LinzeSalesReport/LinzeSalesReport";
import { LinzeSalesReportContainerProps } from "../../interfaces/containers";
import {
    requestLinzeSalesReport,
    checkLinzeSalesReport,
    cleanLinzeSalesReport
} from "../../actions/linzeSalesReport";

function mapStateToProps(state: LinzeSalesReportContainerProps) {
    return {
        linzeSalesReport: state.linzeSalesReport
    };
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        requestLinzeSalesReport,
        checkLinzeSalesReport,
        cleanLinzeSalesReport
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);
